import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=937e3c0a&scoped=true"
import script from "./addMaterial.vue?vue&type=script&lang=js"
export * from "./addMaterial.vue?vue&type=script&lang=js"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=937e3c0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937e3c0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('937e3c0a')) {
      api.createRecord('937e3c0a', component.options)
    } else {
      api.reload('937e3c0a', component.options)
    }
    module.hot.accept("./addMaterial.vue?vue&type=template&id=937e3c0a&scoped=true", function () {
      api.rerender('937e3c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/addMaterial.vue"
export default component.exports